<script>
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  methods: {
    showAutoEnrollment(design) {
      return (
        +design.employee_contrib_plan_uses_autoenroll_picklist_id === 1 ||
        +design.employee_contrib_plan_uses_autoenroll_picklist_id === 2 ||
        +design.employee_contrib_plan_uses_autoenroll_picklist_id === 3
      );
    },
    showAutoEnrollmentPriorEmployees(design) {
      return +design.employee_contrib_plan_uses_autoenroll_picklist_id === 2;
    },
    autoEnrollmentValidations(design) {
      return {
        employee_contrib_plan_uses_autoenroll_picklist_id: { required },
        auto_enrollment_applies_prior_employees: {
          required: requiredIf(() =>
            this.showAutoEnrollmentPriorEmployees(design)
          )
        },
        effective_date_autoenroll: {
          required: requiredIf(() => this.showAutoEnrollment(design))
        },
        initial_deferral_rate_autoenroll: {
          required: requiredIf(() => this.showAutoEnrollment(design)),
          minValue: minValue(0.01),
          maxValue: maxValue(0.15),
          percent: true
        },
        auto_enroll_type: {
          required: requiredIf(() => this.showAutoEnrollment(design))
        }
      };
    }
  }
};
</script>
